import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { RecordEditorPanel } from "../records";
import { financeApi } from "../../lib/api";
import { queryKeys } from "../../lib/queryKeys";
import type { Currency, Group, Tag, Transaction } from "../../lib/types";
import { MonthlyOperationsPreview, type MonthlyOperationsPreviewProps } from "./MonthlyOperationsPreview";

type MonthlyOperationsWithEditorProps = Omit<
  MonthlyOperationsPreviewProps,
  "onOpenTransaction" | "onOpenTransactionId"
> & {
  group: Group;
  tags: Tag[];
  currencies: Currency[];
};

export function MonthlyOperationsWithEditor({
  group,
  tags,
  currencies,
  accounts,
  categories,
  members,
  ...previewProps
}: MonthlyOperationsWithEditorProps) {
  const queryClient = useQueryClient();
  const [editingTransaction, setEditingTransaction] = useState<Transaction | null>(null);

  const openTransactionById = (transactionId: string) => {
    void queryClient.fetchQuery({
      queryKey: queryKeys.record(group.id, transactionId),
      queryFn: () => financeApi.transaction(group.id, transactionId),
    }).then(setEditingTransaction);
  };

  return (
    <>
      <MonthlyOperationsPreview
        {...previewProps}
        accounts={accounts}
        categories={categories}
        members={members}
        onOpenTransaction={setEditingTransaction}
        onOpenTransactionId={openTransactionById}
      />
      {editingTransaction ? (
        <RecordEditorPanel
          key={editingTransaction.id}
          state={{ kind: "edit", transaction: editingTransaction }}
          group={group}
          accounts={accounts}
          members={members}
          categories={categories}
          tags={tags}
          currencies={currencies}
          onClose={() => setEditingTransaction(null)}
        />
      ) : null}
    </>
  );
}
